import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <section className='not-found'>
            <img className='not-found__img-error' src='https://i.ibb.co/0yLjJLg/38.jpg' alt='filmik' />
            <h1 className='not-found__title'>Страница не найдена</h1>
            <p className='not-found__text'>Страница которую вы пытаетесь найти не существует</p>
            <Link className='not-found__btn' to='/?page=1'>Перейти на главную</Link>
        </section>
    );
};

export default NotFoundPage;